import Vue from "vue";
import VueGtag from "vue-gtag";
import router from './vueRouter';
import config from '../config'

Vue.use(VueGtag, {
    config: {id: config.ganalytics}
}, router);
